import { render } from "./FoodAdminPage.vue?vue&type=template&id=516e9e94&scoped=true"
import script from "./FoodAdminPage.vue?vue&type=script&lang=js"
export * from "./FoodAdminPage.vue?vue&type=script&lang=js"

import "./FoodAdminPage.vue?vue&type=style&index=0&id=516e9e94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516e9e94"]])

export default __exports__